export default __webpack_public_path__ + "static/media/thrivingPetsLogo-purple.98a4746d.svg";